<template>
  <div
    v-if="showWarning"
    class="fixed top-4 right-4 bg-yellow-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 max-w-sm"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
        </svg>
        <div>
          <p class="font-semibold">Session Expiring Soon</p>
          <p class="text-sm">You will be logged out in {{ timeLeft }} minutes due to inactivity.</p>
        </div>
      </div>
      <button @click="extendSession" class="ml-4 bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded text-sm font-medium">
        Stay Logged In
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const showWarning = ref(false)
const timeLeft = ref(5)
let warningTimer = null
let countdownTimer = null

function updateLastActivity() {
  try {
    localStorage.setItem('Mina_last_activity', String(Date.now()))
  } catch (e) {
    // ignore storage errors
  }
}

function extendSession() {
  updateLastActivity()
  window.dispatchEvent(new CustomEvent('Mina_user_activity'))
  showWarning.value = false
  clearTimers()
  startWarningTimer()
}

function clearTimers() {
  if (warningTimer) {
    clearTimeout(warningTimer)
    warningTimer = null
  }
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
}

function startWarningTimer() {
  clearTimers()

  // Show warning 5 minutes before expiry
  const INACTIVITY_LIMIT_MS = 30 * 60 * 1000 // 30 minutes
  const WARNING_TIME_MS = 5 * 60 * 1000 // 5 minutes

  warningTimer = setTimeout(() => {
    try {
      const last = parseInt(localStorage.getItem('Mina_last_activity') || '0', 10)
      if (last && Date.now() - last > INACTIVITY_LIMIT_MS - WARNING_TIME_MS) {
        showWarning.value = true
        timeLeft.value = 5

        countdownTimer = setInterval(() => {
          timeLeft.value--
          if (timeLeft.value <= 0) {
            clearTimers()
            showWarning.value = false
          }
        }, 60000) // Update every minute
      }
    } catch (err) {
      console.error('Warning timer error', err)
    }
  }, INACTIVITY_LIMIT_MS - WARNING_TIME_MS)
}

onMounted(() => {
  // Only show warning if user is logged in
  if (localStorage.getItem('Mina_auth')) {
    startWarningTimer()
  }
  window.addEventListener('Mina_user_activity', handleActivity)
})

function handleActivity() {
  if (showWarning.value) {
    showWarning.value = false
  }
  startWarningTimer()
}

onUnmounted(() => {
  clearTimers()
  window.removeEventListener('Mina_user_activity', handleActivity)
})
</script>

<style scoped>
/* Additional styles if needed */
</style>